import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import config from "../../../config";

const baseUrl = config.baseUrl;

const styles = StyleSheet.create({
  // Estilos base de página
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 100,
    fontFamily: "Times-Roman",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },

  // Estilos de títulos y textos
  title: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  title_1: {
    fontSize: 13,
    textAlign: "left",
    fontWeight: "800",
    marginTop: 2,
  },
  title_respuesta: {
    fontSize: 10,
    marginTop: 7,
    textAlign: "justify",
    marginBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    textDecoration: "underline",
  },
  textareaLabel: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },

  // Estilos de header y logo
  header: {
    marginBottom: 20,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  banner: {
    width: "100%",
    height: 40,
  },

  // Estilos de la columna de información
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },

  // Estilos de tabla
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableHeader: {
    backgroundColor: "#f2f2f2",
    fontWeight: "800",
  },
  tableCol: {
    width: "33%",
    padding: 5,
    textAlign: "center",
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    fontSize: 10,
    padding: 5,
  },

  // Estilos de checkbox
  checkboxContainerHorizontal: {
    flexDirection: "column",
    marginTop: 7,
  },
  checkboxContainer: {
    flexDirection: "row",
    marginBottom: 10,
  },
  checkboxGroup: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
    width: "100%",
  },
  checkbox: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: "#000",
    marginRight: 8,
    backgroundColor: "#fff",
  },
  checkboxText: {
    fontSize: 10,
  },

  // Estilos de firma
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 30,
    marginBottom: 30,
  },
  signature: {
    width: 130,
    height: 70,
    marginBottom: 5,
    alignSelf: "center",
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginTop: 10,
  },
  signatureText: {
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Times-Roman",
  },

  signatureImage: {
    width: 200,
    height: 70,
  },
  // Estilos de footer
  footer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: "center",
    fontSize: 10,
  },
  footerSpacer: {
    flexGrow: 1,
  },

  // Estilos de texto generales
  text: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  codeText: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "center",
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 20,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Times-Bold", // <-- Esta línea hace el texto en negrita
  },
});

const MyDocument = ({ formData }) => {
  if (!formData) {
    return (
      <Document>
        <Page style={styles.page}>
          <Text>No hay datos disponibles</Text>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page style={styles.page}>
        <View fixed>
          <View style={styles.headerTable} fixed>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>

            <View style={styles.infoColumn}>
              <View style={styles.codeRow}>
                <Text style={styles.codeText}>CÓDIGO: IR-F-113</Text>
              </View>
              <View style={styles.dateVersionRow}>
                <View style={styles.dateCell}>
                  <Text style={styles.text}>FECHA: 2020-07-14</Text>
                </View>
                <View style={styles.versionCell}>
                  <Text style={styles.text}>VERSIÓN: V-1</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        <Text style={styles.title}>Consentimiento Informado</Text>

        <View>
          <Text style={styles.textareaLabel}>
            Buenos días, mi nombre es {formData?.user_name || ""}. Actualmente
            estamos realizando la recolección primaria de información respecto
            al línea base de las personas en proceso de reincoporacion y sus
            unidades productivas. La Organización de las Naciones Unidas para la
            Agricultura y la Alimentación FAO en el marco del proyecto
            UTF/COL/188/COL "Fortalecimiento de la sostenibilidad de los
            procesos de reincorporación económica y social", con el objetivo de
            fortalecer las capacidades institucionales de la ARN, de las
            personas y de las organizaciones sujetas del proceso de
            reincorporación, acompañando técnicamente la labor de la ARN en la
            implementación y sostenibilidad de los proyectos productivos
            aprobados por el CNR, brindando asistencia técnica especializada
            según la actividad específica de cada emprendimiento. Cuyos
            resultados son : Producto 1. La ARN, avanza en la implementación de
            la oferta institucional denominada estrategia de sostenibilidad que
            fortalece las capacidades productivas y de generación de ingresos de
            las personas en proceso de reincorporación a través del apoyo y
            capitalización de proyectos e iniciativas rurales.Producto 2.
            Personas en proceso de reincorporación cuentan con asistencia
            técnica integral, para los proyectos productivos individuales e
            individuales asociativos desembolsados. Es muy importante su
            participación y los datos que usted nos suministre serán utilizados
            únicamente con fines estadísticos, y estarán protegidos en
            concordancia con las disposiciones de la Ley 1581 de 2012 y la
            Constitución Política de Colombia, sin perjuicio de los privilegios
            e inmunidades de la Organización de las Naciones Unidas para la
            Alimentación y la Agricultura. Para cualquier información al
            respecto puede verificar con la Representación de FAO en Bogotá
            Teléfono: (57) +1 346 51 01 ext.: 135
          </Text>
        </View>
        <View>
          <Text style={styles.textareaLabel}>
            Acepta el consentimiento informado:{" "}
            {formData?.acepta_consentimiento || ""}
          </Text>

          <Text style={styles.textareaLabel}>
            Nombre del informante: {formData?.nombre_participante || ""}
          </Text>
        </View>
        <View style={styles.signatureContainer}>
          <View style={[styles.signature, { width: "100%" }]}>
            {formData?.firma_participante &&
              formData.firma_participante.trim() !== "" ? (
              <>
                <Image
                  style={styles.signatureImage}
                  src={`${baseUrl + formData.firma_participante
                    }?t=${Date.now()}`}
                />
                <View style={[styles.signatureLine, { width: "50%" }]} />
                <Text style={styles.signatureText}>
                  {formData?.nombre_participante || ""}
                </Text>
              </>
            ) : (
              <>
                <Text style={{ color: "#888", fontSize: 12 }}>
                  Firma no disponible
                </Text>
                <View style={styles.signatureLine} />
                <Text style={styles.signatureText}>
                  {formData?.nombre_participante || ""}
                </Text>
              </>
            )}
          </View>
        </View>

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfAlmacenarConsentimiento = ({ formData }) => {
  return <MyDocument formData={formData} />;
};

export default PdfAlmacenarConsentimiento;
